








































































































































import { Component, Vue } from "vue-property-decorator";
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import Buttons from "@/components/Buttons.vue";
import Promotion from "@/components/Promotion.vue";

@Component({
  components: {
    Buttons,
    Navbar,
    Footer,
  },
})


export default class Garantias extends Vue {}

